import { removeStorageItem } from "./storageFunction";

export const removeExpiredFormStorage = (expiryPrefix = "form-exp-time-", maxAgeMs = 24 * 60 * 60 * 1000) => {
  //maxAgeMs = 24 hours
  const now = Date.now();
  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index++) {
    const keyName = localStorage.key(index);

    if (!keyName || !keyName.startsWith(expiryPrefix)) {
      continue;
    }

    const expiryValue = localStorage.getItem(keyName);
    const expiryTime = Number(expiryValue);

    if (!Number.isFinite(expiryTime)) {
      continue;
    }

    if (now - expiryTime > maxAgeMs) {
      const formDataKey = keyName.slice(expiryPrefix.length);
      keysToRemove.push(formDataKey);
      keysToRemove.push(keyName);
    }
  }

  if (keysToRemove.length) {
    removeStorageItem("", keysToRemove);
  }
};
